var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 2.89543 4.89543 2 6 2C7.10457 2 8 2.89543 8 4L4 4ZM2 4C2 1.79086 3.79086 0 6 0C8.20914 0 10 1.79086 10 4H11C11.5523 4 12 4.44772 12 5V11C12 11.5523 11.5523 12 11 12H1C0.447715 12 0 11.5523 0 11V5C0 4.44772 0.447715 4 1 4L2 4ZM5 7C5 6.44772 5.44772 6 6 6C6.55228 6 7 6.44772 7 7V9C7 9.55228 6.55228 10 6 10C5.44772 10 5 9.55228 5 9V7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b34e116fbb2dd9c3d3d64271e4d93172.svg";
export { ForwardRef as ReactComponent };